<template>
  <list />
</template>
<script>
import list from "../components/list";
export default {
  name: "announcement-list",
  components: {
    list
  }
};
</script>
